// ----------------------------------------------------------------------------
// Animations
// ----------------------------------------------------------------------------
//
// Stores all iamota animation variation for reference into individual components.
//
// ----------------------------------------------------------------------------

// -------------------------------------
// Dependencies
// -------------------------------------

import $ from 'jquery';


// -------------------------------------
// Load Styles
// -------------------------------------

import './animations.scss';


// -------------------------------------
// Hooks
// -------------------------------------

document.addEventListener('DOMContentLoaded', function() {
    function scrollAnimation () {
        $.fn.visible = function(partial) {
            var $t            = $(this),
                $w            = $(window),
                viewTop       = $w.scrollTop(),
                viewBottom    = viewTop + $w.height(),
                _top          = $t.offset().top + 200,
                _bottom       = _top + $t.height(),
                compareTop    = partial === true ? _bottom : _top,
                compareBottom = partial === true ? _top : _bottom;

            return ((compareBottom <= viewBottom) && (compareTop >= viewTop));
        };

        var animatedComponent = document.querySelectorAll('.animate-in, .animate-in--no-opacity');

        // Already visible modules
        animatedComponent.forEach(function(el) {
            var $this = $(el);

            if ($this.visible(true)) {
                $this.addClass('already-visible');
            }
        });

        // Check visibility when the user scrolls
        window.addEventListener('scroll', () => {
            animatedComponent.forEach((el) => {
                var $this = $(el);

                if ($this.visible(true)) {
                    $this.addClass('is-animated');
                }
            });
        }, {
            capture: true,
            passive: true
        });
    }

    scrollAnimation();
});
